import type { ReactElement } from "react";

import type { FilterItemCardProps } from "../../types/props";

import { FilterItemCard } from "./FilterItemCard";
import { StyledBorderedFilterCardWrapper } from "./styles";

const BorderedFilterItemCard = (props: FilterItemCardProps): ReactElement => {
    return (
        <StyledBorderedFilterCardWrapper>
            <FilterItemCard {...props} />
        </StyledBorderedFilterCardWrapper>
    );
};

export default BorderedFilterItemCard;
